import {Component, OnInit} from '@angular/core';
import {UserCardReviewService, Page} from '../../service/user-card-review.service';
import {ReviewForAdminResponse} from '../../interface/reviewForAdminResponse';
import {UserService} from '../../service/user.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {MockupDataModel} from "../../qr-copy-message/mockup-data.model";
import {SnackBarUtil} from "../../qr-copy-message/snack-bar-util.service";


@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss', '../users-cards/users-cards.component-media.scss']
})
export class ReviewsComponent implements OnInit {
  protected reviews: ReviewForAdminResponse[] = [];
  protected page: number = 0;
  protected size: number = 10;
  protected totalPages: number = 0;
  protected totalElements: number = 0;
  protected reviewsCount: number = 0;

  constructor(
    private reviewService: UserCardReviewService,
    protected userService: UserService,
    private snackBar: MatSnackBar,
    private router: Router,
    private snackBarUtil: SnackBarUtil
  ) {
  }

  public get user(): UserService {
    return this.userService;
  }

  ngOnInit(): void {
    this.loadReviews();
    this.loadReviewsCount();
  }

  protected loadReviews(page: number = 0): void {
    this.reviewService.getAllReviews(page, this.size).subscribe({
      next: (res: Page<ReviewForAdminResponse>) => {
        this.reviews = res.content.map(r => ({...r, showFullReview: false}));
        this.page = res.number;
        this.size = res.size;
        this.totalPages = res.totalPages;
        this.totalElements = res.totalElements;
      }
    });
  }

  protected loadReviewsCount(): void {
    this.reviewService.getCountOfReviews().subscribe({
      next: (count: number) => {
        this.reviewsCount = count;
      },
      error: (err: HttpErrorResponse) => {
        const errorMsg = err.error?.message || err.statusText || 'Unknown error';
        throw new Error(`Failed to load review count: ${errorMsg} (Status: ${err.status})`);
      }
    });
  }

  protected toggleReview(row: ReviewForAdminResponse): void {
    row.showFullReview = !row.showFullReview;
  }

  protected goToPage(page: number): void {
    if (page >= 0 && page < this.totalPages && page !== this.page) {
      this.loadReviews(page);
    }
  }

  protected getPageNumbers(): number[] {
    return Array(this.totalPages).fill(0).map((_, i) => i + 1);
  }


  protected deleteReview(reviewId: number): void {
    this.reviewService.deleteReviewById(BigInt(reviewId)).subscribe({
      next: () => {
        this.loadReviews(this.page);
        this.openSnackBar(MockupDataModel.success('Review was successfully deleted.'), SnackBarUtil.CLASSES.success);
      }
    });
  }

  private openSnackBar(data: MockupDataModel, classList: string[]) {
    this.snackBarUtil.openSnackBar({
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: classList,
      data: data
    });
  }

  protected navigateToUserSinglePage(userCardId: string): void {
    this.router.navigate(['/', userCardId]);
  }
}
